import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helpers, Routes } from "utils";

// Use a generic to define the type of the data property
type ParameterContextType<T = any> = {
  token: string;
  params: T;
};

export const ParameterContext = createContext<ParameterContextType<any>>({
  token: "",
  params: {},
});

export const ParameterProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [params, setParams] = useState<any>({});

  useEffect(() => {
    if (token) {
      try {
        const decoded = Helpers.decodeUrl(token);
        setParams(decoded);
      } catch (err) {
        // TODO : handle error
        navigate(Routes.home);
      }
    } else {
      setParams({});
    }
  }, [navigate]);

  const MemoizedValue = React.useMemo(() => {
    const value: ParameterContextType = { token: token || "", params };
    return value;
  }, [token, params]);

  return (
    <ParameterContext.Provider value={MemoizedValue}>
      {children}
    </ParameterContext.Provider>
  );
};

export const useParameter = <T = any,>(): ParameterContextType<T> => {
  const context = useContext(ParameterContext);
  if (!context)
    throw new Error("useParameter must be used within ParameterProvider");
  return context;
};
